module.exports = __webpack_public_path__ + "img/Taruna-maskot-2.5a80e212.png";